import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import UserService from '@/services/UserService';
import { bus } from '@/eventBus';
export default {
  name: 'Jumbotron',
  props: {
    loggedIn: {
      type: Boolean,
      default: false
    },
    sidebarCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      networkInfo: null,
      channelId: null
    };
  },
  async mounted() {
    await this.getNetworkInfo();
    bus.$on('setChannel', channel => {
      this.channelId = channel;
    });

    // vue-router 4/5: currentRoute is a Ref. Use this.$route (the resolved
    // proxy installed on globalProperties) instead.
    const path = this.$route && this.$route.path || '';
    if (path.includes('video/channel')) {
      if (path === '/video/channel' || path === '/video/channel/') {
        this.channelId = 0;
      } else {
        this.channelId = this.$route && this.$route.params && this.$route.params.id || null;
      }
    }
  },
  computed: {
    activeChannel() {
      if (!this.networkInfo || !this.channelId || +this.channelId <= 0 || !this.networkInfo.channels) {
        return null;
      }
      let channel = null;
      this.networkInfo.channels.some(e => {
        if (+e.id === +this.channelId) {
          channel = e;
          return true;
        }
        return false;
      });
      return channel;
    },
    headerImageStyle() {
      let image = '/img/profile-banner.png';
      if (this.activeChannel && this.activeChannel.bannerimage_display) {
        image = this.activeChannel.bannerimage_display;
      } else if (this.networkInfo && this.networkInfo.headerimage_display) {
        image = this.networkInfo.headerimage_display;
      }
      return {
        backgroundImage: `linear-gradient(rgba(17, 24, 39, 0.32), rgba(17, 24, 39, 0.32)), url("${image}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
    },
    profileImageUrl() {
      if (this.activeChannel && this.activeChannel.logoimage_display) {
        return this.activeChannel.logoimage_display;
      } else if (this.networkInfo && this.networkInfo.profileimage_display) {
        return this.networkInfo.profileimage_display;
      } else if (this.networkInfo && this.networkInfo.logoimage_display) {
        return this.networkInfo.logoimage_display;
      }
      return null;
    }
  },
  methods: {
    async getNetworkInfo() {
      this.networkInfo = await UserService.getNetworkInfo();
    }
  }
};